export default __webpack_public_path__ + "static/media/media-flyer-2.ac3dbb58.jpg";